


























































import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'
import DatasetCard from '../components/Dataset/DatasetCard.vue'
import Summary from '../components/Summary/Summary.vue'
import DatabasesStatus from '../components/DatabasesStatus/DatabasesStatus.vue'
import ShareBanner from '../components/Banner/ShareBanner.vue'
import SummaryImage from '../components/SummaryImage/SummaryImage.vue'

import firebase from 'firebase/app'
import 'firebase/functions'
import { DATASETS_STATUSES, DATABASE_STATUSES } from '@/config/constants'

export default Vue.extend({
  name: 'CheckResult',
  components: {
    DatasetCard,
    Summary,
    DatabasesStatus,
    ShareBanner,
    SummaryImage
  },
  data: () => ({
    countries: [
      'Colombia',
      'México',
      'Brazil',
      'Perú'
    ],
    identificationTypes: [
      'Cédula',
      'Cédula de extranjería',
      'Permiso especial de permanencia'
    ],
    identificationNumber: '',
    filters: false,
    showDatabasesStatuses: false,
    databases: [],
    checkID: '',
    check: {} as any,
    details: [] as any[],
    datasets: [] as any[],
    loading: true,
    token: '',
    datasetNames: {
      personal_identity: 'Identidad personal',
      criminal_record: 'Antecedentes penales',
      legal_background: 'Antecedentes legales',
      international_background: 'Antecedentes internacionales',
      affiliations_and_insurances: 'Afiliaciones y seguros',
      taxes_and_finances: 'Impuestos y finanzas',
      professional_background: 'Historial profesional',
      alert_in_media: 'Alerta en medios',
      politically_exposed_person: 'Persona políticamente expuesta (PEP)'
    } as Record<string, any>
  }),
  computed: {
    ...mapGetters('results', {
      result: 'getResult',
      headerInfo: 'getHeaderInfo'
    }),
    ...mapGetters('results', ['getResultTabType'])
  },
  methods: {
    ...mapMutations('results', {
      UpdateResults: 'setResult',
      UpdateHeaderInfo: 'setHeaderInfo'
    }),
    ...mapMutations(['updateModalStatus']),
    toogleDatabasesStatuses () {
      this.showDatabasesStatuses = !this.showDatabasesStatuses
    },
    updateExistingCheck (): void {
      const checkId = `CHKdee${new Date().getTime()}`

      setTimeout(() => {
        this.$router.push({ name: 'CheckResult', params: { id: checkId, date: new Date().toString() } })
        window.location.reload()
      }, 1500)
    },
    async fetchCheckResults () {
      if (this.$route.name !== 'CheckResult') {
        return // Avoid running this function if view changes
      }

      const response = await firebase.functions().httpsCallable('getCheck')({
        check_id: this.checkID,
        language: this.$i18n.locale
      })

      this.check = response.data.check
      this.details = response.data.details
      this.token = response.data.token

      this.setHeaderInfo()
      this.setDatasets(this.check, this.details)
      this.setDatabasesStatus(this.check)

      // TODO add not found when check is null

      if (!this.check || this.check.status !== 'completed') {
        setTimeout(this.fetchCheckResults, 4400)
      }
    },
    async setDatasets (check: any, details: any[]) {
      const datasets = {} as Record<string, any>

      if (!check || !check.statuses) return

      check.statuses.forEach((status: any) => {
        if (status.data_set === undefined) return

        if (datasets[status.data_set] === undefined) {
          datasets[status.data_set] = {
            status: DATASETS_STATUSES.inProgress,
            name: this.datasetNames[status.data_set] || status.data_set,
            totalSources: 0,
            completedSources: 0,
            progress: 0,
            details: []
          }
        }

        if (status.status === 'skipped') return

        datasets[status.data_set].totalSources++

        if (status.status === 'completed' || status.status === 'expired' || status.status === 'error') {
          datasets[status.data_set].completedSources++
        }
      })

      check.scores.forEach((score: any) => {
        if (score.data_set === undefined) return

        if (datasets[score.data_set] === undefined) return

        datasets[score.data_set].score = Math.round(score.score * 10)
      })

      details.forEach(detail => {
        if (detail.data_set === '') return

        if (detail.tables === null) return

        datasets[detail.data_set].details.push(detail)
      })

      const datasetsArray = [] as any[]

      Object.entries(datasets).forEach(([datasetName, dataset]) => {
        let datasetProgress = Math.round((dataset.completedSources / dataset.totalSources * 100) * 100) / 100
        let datasetStatus = DATASETS_STATUSES.inProgress

        // Possible when all bases of a dataset are on 'skipped'
        if (dataset.totalSources === 0) {
          datasetProgress = 100
        }

        if (datasetProgress === 100) {
          datasetStatus = DATASETS_STATUSES.finished
        }

        datasetsArray.push({
          id: datasetName,
          ...dataset,
          sources: `${dataset.completedSources}/${dataset.totalSources}`,
          progress: datasetProgress,
          status: datasetStatus
        })
      })

      this.datasets = datasetsArray
      this.loading = false
    },
    async setDatabasesStatus (check: any) {
      if (!check || !check.statuses) return

      const datasets = {} as Record<string, any>

      check.statuses.forEach((status: any) => {
        if (status.data_set === undefined || status.status === 'skipped') return

        if (datasets[status.data_set] === undefined) {
          datasets[status.data_set] = []
        }

        datasets[status.data_set].push({
          enabled: status.status === DATABASE_STATUSES.completed,
          name: status.database_name
        })
      })

      const databases = [] as any

      Object.entries(datasets).forEach(([datasetName, sources]) => {
        databases.push({
          dataset: this.datasetNames[datasetName as string] || datasetName as string,
          sources: sources
        })
      })

      this.databases = databases
    },
    getDocumentInformation () : {documentType:string, documentNumber:string } {
      let documentType = ''
      let documentNumber = ''

      if (!this.check) return { documentType: '', documentNumber: '' }

      if (this.check.national_id) {
        documentType = 'national_id'
        documentNumber = this.check.national_id
        return { documentType, documentNumber }
      }

      if (this.check.foreign_id) {
        documentType = 'foreign_id'
        documentNumber = this.check.foreign_id
        return { documentType, documentNumber }
      }

      if (this.check.tax_id) {
        documentType = 'tax_id'
        documentNumber = this.check.tax_id
        return { documentType, documentNumber }
      }

      if (this.check.pep) {
        documentType = 'pep'
        documentNumber = this.check.pep
        return { documentType, documentNumber }
      }

      return { documentType: '', documentNumber: '' }
    },
    setHeaderInfo () : void {
      const countriesMap = {
        CO: 'Colombia',
        MX: 'México',
        CL: 'Chile',
        BR: 'Brazil',
        PE: 'Perú'
      } as Record<string, any>

      const documentTypesMap = {
        CO: {
          national_id: 'Cédula de ciudadanía',
          pep: 'Permiso especial de permanencia',
          foreign_id: 'Cédula de extranjería',
          tax_id: 'NIT'
        },
        MX: {
          national_id: 'CURP'
        },
        CL: {
          national_id: 'RUT'
        },
        BR: {
          national_id: 'Cadastro de pessoa física (CPF)'
        },
        PE: {
          national_id: 'DNI'
        }
      } as Record<string, Record<string, any>>

      const { documentType, documentNumber } = this.getDocumentInformation()

      this.UpdateHeaderInfo({
        country: countriesMap[this.check.country],
        documentType: documentTypesMap[this.check.country][documentType],
        documentNumber
      })
    }
  },
  watch: {
    showDatabasesStatuses (): void {
      this.updateModalStatus(this.showDatabasesStatuses)
    },
    '$route.params.id' () {
      this.checkID = this.$route.params.id
      this.loading = true
      this.fetchCheckResults()
    }
  },
  mounted () {
    this.datasetNames = {
      personal_identity: this.$t('Identidad personal'),
      criminal_record: this.$t('Antecedentes penales'),
      legal_background: this.$t('Antecedentes legales'),
      international_background: this.$t('Antecedentes internacionales'),
      affiliations_and_insurances: this.$t('Afiliaciones y seguros'),
      taxes_and_finances: this.$t('Impuestos y finanzas'),
      professional_background: this.$t('Historial profesional'),
      alert_in_media: this.$t('Alerta en medios'),
      politically_exposed_person: this.$t('Persona políticamente expuesta (PEP)')
    } as Record<string, any>

    this.checkID = this.$route.params.id
    this.fetchCheckResults()
  }
})
